<h3>Language Selector</h3>
<div class="section">
    <form (change)="saveLanguage()">
        <p>Selected language: {{selectedLanguage}}</p>
        <label>
            <select class="language" name="language" [(ngModel)]="selectedLanguage">
                <option value="" [attr.selected]="!selectedLanguage ? 'selected' : null">Select a language</option>
                @for (location of locations; track location.name) {
                    <optgroup [attr.label]="location.name">
                        @for (language of location.values; track language.value) {
                            <option
                                [attr.value]="language.value"
                                [attr.selected]="selectedLanguage === language.value ? 'selected' : null"
                            >
                                ({{language.value}}) {{language.name}}
                            </option>
                        }
                    </optgroup>
                }
            </select>
        </label>
    </form>
</div>
